export const fromGExcelToTable = (data) => {
    if (!data) {
        return {};
    }

    const splitToList = data.split(/\n/g)

    if (splitToList.length === 0) {
        return {};
    }

    const [header, ...rows] = splitToList;

    const headers = header.split(',').map((title = '', index) => ({
          text: title.trim().toUpperCase().replace(/(["'])/g, ''),
          align: 'start',
          sortable: false,
          value: `header_${index}_${title.trim().toLowerCase().replace(/(["'])/g, '').replace(/(\s)/g, '_')}`,
      }));

    const items = rows
    .map((row) => {
      const tableRow = {};

        row
        .split(',')
        .forEach((currentValue, index) => {
          const key = (headers[index] || {}).value || 'unknown';

          tableRow[key] = currentValue || '--'
        })

        return tableRow;
    })

    return {
        headers,
        items
    }
}
